<template>
    <div>
        <div class="d-flex justify-content-end">
            <b-button size="sm" @click="reloadClientOrderRequests"><i class="fas fa-sync mr-2"></i>Refresh</b-button>
        </div>
        <b-table striped hover slim :items="clientOrderRequests" :fields="tableFields" primary-key="clientOrderRequestId" class="mt-1" show-empty>
            <template #cell(actions)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2" :disabled="row.item.uploadInProgress">
                    {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                </b-button>
            </template>
            <template #row-details="row">
                <b-card>
                    <attachments relatedTo="ClientOrderRequest"
                                 :relatedToId="row.item.clientOrderRequestId"
                                 :allAttachmentClassifications="allAttachmentClassifications"
                                 :attachments="row.item.attachments"
                                 :includeAwaitingFurtherAttachments="true"
                                 :initialAwaitingFurtherAttachments="true"
                                 attachment-classification-selection="required"
                                 :canAddAttachments="allAttachmentClassifications && allAttachmentClassifications.length"
                                 v-on:uploadInProgress="(uploadInProgress) => row.item.uploadInProgress = uploadInProgress"></attachments>
                </b-card>
            </template>
        </b-table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';

    import Attachments from './Attachments';

    import DateTimeMixin from '../mixins/DateTimeMixin';
    import UuidMixins from '../mixins/UuidMixins';
    import ErrorsMixin from '../mixins/ErrorsMixin';

    Vue.component('attachments', Attachments);

    export default {
        name: 'FileUpload',
        mixins: [DateTimeMixin, UuidMixins, ErrorsMixin],
        props: {
            allAttachmentClassifications: {
                type: Array,
                required: true
            }
        },
        data: function () {
			return {
                clientOrderRequests: null,
                clientOrderRequestIdsWithUploadInProgress: [],
                clientOrderRequestIdsWithDetailsShowing: []
			}
        },
        computed: {
            tableFields: function () {
                return [
                    {
                        key: 'orderRequestNumberDisplayText',
                        label: 'Request #',
                        thStyle: { width: '120px' },
                        sortable: true
                    },
                    {
                        key: 'clientReference',
                        label: 'Client Reference',
                        sortable: true
                    },
                    {
                        key: 'matterNumber',
                        label: this.$t("Entities.Shared.MatterNumber"),
                        sortable: true
                    },
                    {
                        key: 'matterName',
                        label: this.$t("Entities.Shared.MatterName"),
                        sortable: true
                    },
                    {
                        key: 'courtSittingDate',
                        label: 'Sitting Date',
                        formatter: value => {
                            return this.formatDateTime(value, 'DD/MM/YYYY hh:mma', true, false);
                        },
                        sortable: true
                    },
                    {
                        key: 'interviewOrganisation',
                        label: 'Interview Organisation',
                        sortable: true
                    },
                    {
                        key: 'Actions',
                        label: 'Actions'
                    }
                ];
            }
        },
        methods: {
            reloadClientOrderRequests: function () {
                if (this.clientOrderRequests) {
                    this.clientOrderRequestIdsWithUploadInProgress = [];
                    this.clientOrderRequestIdsWithDetailsShowing = [];
                    this.clientOrderRequests.forEach(clientOrderRequest => {
                        if (clientOrderRequest.uploadInProgress) this.clientOrderRequestIdsWithUploadInProgress.push(clientOrderRequest.clientOrderRequestId);
                        if (clientOrderRequest._showDetails) this.clientOrderRequestIdsWithDetailsShowing.push(clientOrderRequest.clientOrderRequestId);
                    })
                }
                var url = this.$urlHelper.getApiUrl('ClientOrderRequest', 'list/awaitingFurtherAttachments');
                axios
                    .get(url)
                    .then(response => {
                        var clientOrderRequests = response.data;
                        clientOrderRequests.map(clientOrderRequest => {
                            clientOrderRequest.uploadInProgress = false;
                            if (this.clientOrderRequestIdsWithUploadInProgress.indexOf(clientOrderRequest.clientOrderRequestId) > -1) {
                                clientOrderRequest.uploadInProgress = true;
                                clientOrderRequest._showDetails = true;
                            } else if (this.clientOrderRequestIdsWithDetailsShowing.indexOf(clientOrderRequest.clientOrderRequestId) > -1) {
                                clientOrderRequest._showDetails = true;
                            }
                            return clientOrderRequest;
                        })
                        this.clientOrderRequests = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
            }
        },
        mounted: function() {
            this.reloadClientOrderRequests();
        }
}
</script>
<style>
	#container {
		visibility: hidden;
		padding-left: 5%;
		width: 100%;
	}

	#loader {
		color: #008cff;
		font-family: 'Helvetica Neue','calibiri';
		font-size: 14px;
		height: 40px;
		left: 45%;
		position: absolute;
		top: 45%;
		width: 30%;
	}

	.chunk .control_wrapper {
		max-width: 450px;
		min-width: 245px;
		margin: auto;
	}

	#chunkupload .e-upload.e-control {
		position: relative;
		margin: 15px 0;
	}

	.control-section .uploader.col-lg-8 {
		padding: 20px;
	}
    .custom_progress .e-upload .e-upload-files .e-upload-file-list .e-file-container .e-progress-inner-wrap .e-upload-progress-bar.e-upload-progress {
        background: yellow;
        height: 4px;
    }

    .custom_progress .e-upload .e-upload-files .e-upload-file-list .e-file-container .e-progress-inner-wrap {
        height: 4px;
        background-color: lightblue;
    }

    .preloadfiles .control_wrapper {
        max-width: 450px;
        min-width: 245px;
        margin: auto;
    }

    #preloadFiles .e-upload.e-control {
        position: relative;
        margin: 15px 0;
    }

    .control-section.preloadfiles .uploader-preload.col-lg-8 {
        padding: 20px;
    }
</style>
